import { render, staticRenderFns } from "./PriceAdjustment.vue?vue&type=template&id=0f15a1f1&"
import script from "./PriceAdjustment.vue?vue&type=script&lang=js&"
export * from "./PriceAdjustment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports